import EventSlideOut from './EventSlideOut';

export default EventSlideOut;
